// extracted by mini-css-extract-plugin
export var compactFilters = "_gy-4";
export var detailImage = "_gy-1";
export var dropdownContainer = "_gy-2";
export var imageContainer = "_gy-0";
export var selectedCard = "_gy-3";